import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/properties.js';
import q from '../query.js';
export const propertiesEntity = 'properties';
export const propertyTypesEntity = 'property-types';
export const propertyTypesKey = `property-types`;
export const usePropertyTypes = () => q.query(propertyTypesKey, () => api.getTypes(), keys.read.collection(propertyTypesEntity));
export const propertiesKey = (ref, refId) => `properties-${ref}-${refId}`;
export const useProperties = (ref, refId) => q.query(propertiesKey(ref, refId), () => api.get({ ref, refId }), keys.read.collection(propertiesEntity));
//# sourceMappingURL=index.js.map